import { jsx } from 'react/jsx-runtime';
import * as React from 'react';
import { forwardRef } from 'react';

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function SvgExecutive(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 8C14 9.10457 13.1046 10 12 10C10.8954 10 10 9.10457 10 8C10 6.89543 10.8954 6 12 6C13.1046 6 14 6.89543 14 8ZM15 8C15 9.65685 13.6569 11 12 11C10.3431 11 9 9.65685 9 8C9 6.34315 10.3431 5 12 5C13.6569 5 15 6.34315 15 8ZM19 18.2222L19 19H5.00007L5.00009 18.8531L5.0001 18.5L5.00007 18.2798L5 18.2222L5.00007 18.1937C5.0004 18.1289 5.00184 18.0643 5.00438 18C5.0099 17.8602 5.02061 17.7216 5.03634 17.5843C5.39572 14.4475 8.37631 12 12 12C15.7823 12 18.864 14.6665 18.9956 18C18.9982 18.0666 18.9997 18.1334 19 18.2004L19 18.2222ZM12 13C15.3359 13 17.8617 15.3164 17.9945 18H6.0055C6.13832 15.3164 8.66406 13 12 13Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExecutive);

var ExecutiveOutline = forwardRef((props, ref) => jsx(ForwardRef, Object.assign({
  ref: ref
}, props)));

export { ExecutiveOutline as default };
